import * as React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import NoPage from "./pages/NoPage";
import Login from "./pages/Login";
import MainDashboard from "./pages/MainDashboard";
import PatchingDashboard from "./pages/PatchingDashboard";
import SpaceAllocationDashboard from "./pages/SpaceAllocationDashboard";
import TrayImportDashboard from "./pages/Inventory/TrayImportDashboard";
import UsersDashboard from "./pages/HR/UsersDashboard";
import InventoryDashboard from "./pages/InventoryDashboard";
import SettingsDashboard from "./pages/SettingsDashboard";
import PatchingList from "./pages/PatchingList";
import PatchingCombifix from "./pages/PatchingCombifix";
import PatchingProduction from "./pages/PatchingProduction";
import PatchingShortagesExtras from "./pages/PatchingShortagesExtras";
import Greenhouses from "./pages/SpaceAllocation/Greenhouses";
import Users from "./pages/HR/Users";
import Crews from "./pages/HR/Crews";
import TrayImport from "./pages/Inventory/TrayImport";
import Inventory from "./pages/Inventory/Inventory";
import Settings from "./pages/Settings";
import Profile from "./pages/Profile";
import GrowingDashboard from "./pages/Growing/GrowingDashboard";
import DailyTasks from "./pages/Growing/DailyTasks";
import Training from "./pages/Growing/Training";
import ChemicalInventory from "./pages/Growing/ChemicalInventory";
import SprayRecords from "./pages/Growing/SprayRecords";
import Feeding from "./pages/Growing/Feeding";
import ReportShortagesExtras from "./components/Report_ShortagesExtras";
import ReportProduction from "./components/Report_Production";
import SubreportProduction from "./components/Subreport_Production";
import ReportInventory from "./components/Report_Inventory";
import ReportSprayRecords from "./components/Report_SprayRecords";
import ReportPo from "./components/Report_Po";
import ConfirmDialog from "./components/ConfirmDialog";
import ErrorDialog from "./components/ErrorDialog";
import DialogDelete from "./components/DialogDelete";
import LogisticsDashboard from "./pages/Logistics/LogisticsDashboard";
import { Scheduler } from "./pages/Logistics/Scheduler/Scheduler";
import { DeliveryManifest } from "./pages/Logistics/DeliveryManifest/DeliveryManifest";
import { RoutesDeliveries } from "./pages/Logistics/RoutesDeliveries/RoutesDeliveries";
import { RouteAccordion } from "./pages/Logistics/RouteAccordion/RouteAccordion";
import { DebugEndpoints } from "./pages/Logistics/DebugEndpoints/DebugEndpoints";
import InvoicingDashboard from "./pages/Invoicing/InvoicingDashboard";
import { Invoices } from "./pages/Invoicing/Invoices";
import { InvoiceSettings } from "./pages/Invoicing/InvoiceSettings";
import ShippingDashboard from "./pages/Shipping/ShippingDashboard";
import { DeliveryListUploader } from "./pages/Shipping/DeliveryListUploader";
import { BoxOrdersPickList } from "./pages/Shipping/BoxOrders/BoxOrdersPickList";
import { PickList } from "./pages/Shipping/GrowerTruck/PickList";
import { DeliveryLists } from "./pages/Shipping/DeliveryLists/DeliveryLists";
import { ShippingPreview } from "./pages/Shipping/ShippingPreview/ShippingPreview";
import PoHeader from "./pages/PO/PoHeader";
import PoByOrderDetails from "./pages/PO/PoByOrderDetails";
import PoByItemDetails from "./pages/PO/PoByItemDetails";
import PoReview from "./pages/PO/PoReview";
import PoOrder from "./pages/PO/PoOrder";
import PoDashboard from "./pages/PO/PoDashboard";
import PoRecords from "./pages/PO/PoRecords";
import SearchChips from "./components/SearchChips";
import ModuleMenu from "./components/ModuleMenu";
import PoAddItemDialog from "./pages/PO/PoAddItemDialog";
// import CustomerBatch from "./pages/Seeding/CustomerBatch";
// import DirtProduction from "./pages/Seeding/DirtProduction";
// import InternalSeedcatalog from "./pages/Seeding/InternalSeedCatalog";
// import InventoryAssignment from "./pages/Seeding/InventoryAssignment";
// import OrderSeed from "./pages/Seeding/OrderSeed";
// import SeedDemand from "./pages/Seeding/SeedDemand";
// import SeedingLanes from "./pages/Seeding/SeedingLanes";
// import SeedingSettings from "./pages/Seeding/SeedingSettings";
// import SeedInventory from "./pages/Seeding/SeedInventory";
// import SeedProduction from "./pages/Seeding/SeedProduction";
// import SeedReceiving from "./pages/Seeding/SeedReceiving";
// import SowDetails from "./pages/Seeding/SowDetails";
// import SowSummary from "./pages/Seeding/SowSummary";
// import TrayAssignment from "./pages/Seeding/TrayAssignment";
// import WeeklyNotes from "./pages/Seeding/WeeklyNotes";
import ModuleDialog from "./components/ModuleDialog";
import SeedingDashboard from "./pages/Seeding/SeedingDashboard";
import { OrderSeed } from "./pages/Seeding/OrderSeed";
import { SeedDemand } from "./pages/Seeding/SeedDemand";
import { SeedReceiving } from "./pages/Seeding/SeedReceiving";
import { SeedInventory } from "./pages/Seeding/SeedInventory";



//Last deployment 11:20 AM 3/17/2023
function App() {
  return (
    // basename="app"
    <BrowserRouter basename="app">
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route element={<Home />}></Route>
          <Route index path="/Login" element={<Login />}></Route>
          <Route index path="/Report_ShortagesExtras" element={<ReportShortagesExtras />}></Route>
          <Route index path="/Report_Production" element={<ReportProduction />}></Route>
          <Route index path="/Report_Inventory" element={<ReportInventory />}></Route>
          <Route index path="/Report_SprayRecords" element={<ReportSprayRecords />}></Route>
          <Route index path="/Report_Po" element={<ReportPo />}></Route>
          <Route index path="/Subreport_Production" element={<SubreportProduction />}></Route>
          <Route index path="/ConfirmDialog" element={<ConfirmDialog />}></Route>
          <Route index path="/ErrorDialog" element={<ConfirmDialog />}></Route>
          <Route index path="/DialogDelete" element={<ConfirmDialog />}></Route>
          <Route index path="" element={<Login />}></Route>
          <Route path="*" element={<NoPage />} />
        </Route>
        <Route path="/patching" element={<Layout />}>
          <Route index path="/patching/dashboard" element={<PatchingDashboard />} />
          <Route path="/patching/patching-production" element={<PatchingProduction />} />
          <Route path="/patching/patching-list" element={<PatchingList />} />
          <Route path="/patching/patching-combifix" element={<PatchingCombifix />} />
          <Route path="/patching/patching-shortages-extras" element={<PatchingShortagesExtras />} />
          <Route path="/patching/greenhouses" element={<Greenhouses showActionMenu={true} />} />
          <Route path="/patching/tray-import" element={<TrayImport />} />
          <Route path="/patching/users" element={<Users />} />
          <Route path="/patching/inventory" element={<Inventory />} />
          <Route path="*" element={<NoPage />} />
        </Route>
        <Route path="/hr" element={<Layout />}>
          <Route index path="/hr/usersdashboard" element={<UsersDashboard />} />
          <Route path="/hr/users" element={<Users />} />
          <Route path="/hr/crews" element={<Crews />} />
          <Route path="*" element={<NoPage />} />
        </Route>
        <Route path="/growing" element={<Layout />}>
          <Route index path="/growing/dashboard" element={<GrowingDashboard />} />
          <Route path="/growing/dailytasks" element={<DailyTasks />} />
          <Route path="/growing/training" element={<Training />} />
          <Route path="/growing/chemicalinventory" element={<ChemicalInventory />} />
          <Route path="/growing/sprayrecords" element={<SprayRecords />} />
          <Route path="/growing/feeding" element={<Feeding />} />
          <Route path="*" element={<NoPage />} />
        </Route>
        <Route path="/logistics" element={<Layout />}>
          <Route index path="/logistics/dashboard" element={<LogisticsDashboard />} />
          <Route index path="/logistics/scheduler" element={<Scheduler />} />
          <Route index path="/logistics/deliverymanifest" element={<DeliveryManifest />} />
          <Route index path="/logistics/routesdeliveries" element={<RoutesDeliveries />} />
          <Route index path="/logistics/routemanager" element={<RouteAccordion />} />
          <Route index path="/logistics/debugendpoints" element={<DebugEndpoints />} />
          <Route path="*" element={<NoPage />} />
        </Route>
        <Route path="/invoicing" element={<Layout />}>
          <Route index path="/invoicing/dashboard" element={<InvoicingDashboard />} />
          <Route index path="/invoicing/main" element={<Invoices />} />
          <Route index path="/invoicing/settings" element={<InvoiceSettings />} />
          <Route path="*" element={<NoPage />} />
        </Route>
        <Route path="/shipping" element={<Layout />}>
          <Route index path="/shipping/dashboard" element={<ShippingDashboard />} />
          <Route index path="/shipping/shipping_preview" element={<ShippingPreview />} />
          <Route index path="/shipping/delivery_list" element={<DeliveryLists />} />
          <Route index path="/shipping/pick_lists" element={<PickList />} />
          <Route index path="/shipping/box_order_pick_list" element={<BoxOrdersPickList />} />
          <Route index path="/shipping/uploader" element={<DeliveryListUploader />} />
          <Route path="*" element={<NoPage />} />
        </Route>
        <Route path="/" element={<Layout />}>
          <Route index path="/main/maindashboard" element={<MainDashboard />} />
          <Route path="/main/trayimportdashboard" element={<TrayImportDashboard />} />
          <Route path="/main/inventorydashboard" element={<InventoryDashboard />} />
          <Route path="/main/spaceallocationdashboard" element={<SpaceAllocationDashboard />} />
          <Route path="/main/settingsdashboard" element={<SettingsDashboard />} />
          <Route path="/main/growingdashboard" element={<GrowingDashboard />} />
          <Route path="/main/settings" element={<Settings />} />
          <Route path="/main/profile" element={<Profile />} />
          <Route path="*" element={<NoPage />} />
        </Route>
        <Route path="/po" element={<Layout />}>
          <Route index path="/po/podashboard" element={<PoDashboard />} />
          <Route path="/po/poorder" element={<PoOrder />} />
          <Route path="/po/purchaseorders" element={<PoRecords />} />
          <Route path="*" element={<NoPage />} />
        </Route>
        <Route path="/seeding" element={<Layout />}>
          <Route index path="/seeding/dashboard" element={<SeedingDashboard />} />
          <Route index path="/seeding/demand" element={<SeedDemand />} />
          <Route index path="/seeding/order" element={<OrderSeed />} />
          <Route index path="/seeding/receiving" element={<SeedReceiving />} />
          <Route index path="/seeding/inventory" element={<SeedInventory />} />
          {/* <Route path="/seeding/customerbatch" element={<CustomerBatch />} />
        <Route path="/seeding/dirtproduction" element={<DirtProduction />} />
        <Route path="/seeding/internalseedcatalog" element={<InternalSeedcatalog />} />
        <Route path="/seeding/inventoryassignment" element={<InventoryAssignment />} />
        <Route path="/seeding/orderseed" element={<OrderSeed />} />
        <Route path="/seeding/seeddemand" element={<SeedDemand />} />
        <Route path="/seeding/seedinglanes" element={<SeedingLanes />} />
        <Route path="/seeding/seedinventory" element={<SeedInventory />} />
        <Route path="/seeding/seedproduction" element={<SeedProduction />} />
        <Route path="/seeding/seedreceiving" element={<SeedReceiving />} />
        <Route path="/seeding/sowdetails" element={<SowDetails />} />
        <Route path="/seeding/sowsummary" element={<SowSummary />} />
        <Route path="/seeding/trayassignment" element={<TrayAssignment />} />
        <Route path="/seeding/weeklynotes" element={<WeeklyNotes />} /> */}
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>

  );
}

export default App;
